import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonIcon,
  IonInput,
  IonButton,
  IonSpinner,
  IonContent,
} from '@ionic/react';
import { personOutline, atOutline, checkmarkCircleOutline, alertCircleOutline } from 'ionicons/icons';
import { API_BASE_URL } from '../../config';
import { useUser } from '../../context/UserContext';
import { PageHeader, AppBackground } from '../../components/PageHeader';

const EditarPerfil: React.FC = () => {
  const history = useHistory();
  const { user, setUser } = useUser();
  const [nombre, setNombre] = useState(user?.nombre || '');
  const [nickname, setNickname] = useState(user?.nickname || '');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  // Load current user data on component mount
  useEffect(() => {
    if (user) {
      setNombre(user.nombre || '');
      setNickname(user.nickname || '');
    }
  }, [user]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!nombre.trim() || !nickname.trim()) {
      setError('El nombre y el nickname son requeridos.');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/auth/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ nombre, nickname }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al actualizar el perfil');
        return;
      }

      // Guardar nueva información y token actualizados
      localStorage.setItem('token', data.token);
      setUser(data.user);

      setSuccess('Tu perfil ha sido actualizado con éxito.');

      // Redirigir al dashboard para que se vea reflejado el nuevo nombre
      setTimeout(() => {
        history.push('/panel');
      }, 1500);

    } catch (err) {
      setError('No se pudo conectar con el servidor. Verifica tu conexión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage className="app-page">
      <AppBackground />

      <PageHeader title="Mi Perfil" subtitle="Edita tu nombre y tu usuario" backHref="/panel" disabled={loading} />

      <IonContent className="content-transparent ion-padding-horizontal">
        <div className="app-container">
          <div className="app-card">
            <h3 className="app-card-title">Datos Personales</h3>
            <p className="app-card-subtitle">Actualiza tu nombre y tu nombre de usuario.</p>

            <form onSubmit={handleSubmit} className="app-form">
              {/* Nombre de pila */}
              <div className="input-group">
                <span className="input-icon">
                  <IonIcon icon={personOutline} />
                </span>
                <IonInput
                  type="text"
                  placeholder="Nombre completo"
                  value={nombre}
                  onIonInput={(e: any) => setNombre(e.detail.value ?? '')}
                  className="app-input"
                  required
                  disabled={loading}
                />
              </div>

              {/* Nickname */}
              <div className="input-group">
                <span className="input-icon">
                  <IonIcon icon={atOutline} />
                </span>
                <IonInput
                  type="text"
                  placeholder="Nickname de usuario"
                  value={nickname}
                  onIonInput={(e: any) => setNickname(e.detail.value ?? '')}
                  className="app-input"
                  required
                  disabled={loading}
                />
              </div>

              {error && (
                <div className="status-alert alert-error">
                  <IonIcon icon={alertCircleOutline} />
                  <span>{error}</span>
                </div>
              )}

              {success && (
                <div className="status-alert alert-success">
                  <IonIcon icon={checkmarkCircleOutline} />
                  <span>{success}</span>
                </div>
              )}

              <IonButton
                type="submit"
                expand="block"
                className="app-btn-primary"
                disabled={loading}
              >
                {loading ? <IonSpinner name="crescent" /> : 'Guardar Cambios'}
              </IonButton>
            </form>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EditarPerfil;
